/** Month abbreviations as used in legacy ES period ids (e.g. JUL24). */
const MONTH_ABBR: Record<string, number> = {
  JAN: 1,
  FEB: 2,
  MAR: 3,
  APR: 4,
  MAY: 5,
  JUN: 6,
  JUL: 7,
  AUG: 8,
  SEP: 9,
  OCT: 10,
  NOV: 11,
  DEC: 12,
};

function pad2(n: number): string {
  return String(n).padStart(2, '0');
}

/**
 * Legacy Emergency Services period token → full-month YYYYMMDD range (first–last day).
 * e.g. JUL24 → 20240701 … 20240731
 */
export function parseLegacyMonYyRange(period: string): { startYmd: string; endYmd: string } | null {
  const p = period.trim();
  const m = p.match(/^([A-Za-z]{3})(\d{2})$/);
  if (!m) return null;
  const monthNum = MONTH_ABBR[m[1].toUpperCase()];
  if (!monthNum) return null;
  const yy = parseInt(m[2], 10);
  const year = 2000 + yy;
  const lastDay = new Date(year, monthNum, 0).getDate();
  return {
    startYmd: `${year}${pad2(monthNum)}01`,
    endYmd: `${year}${pad2(monthNum)}${pad2(lastDay)}`,
  };
}

/**
 * Human-facing period label aligned with logistics: "YYYYMMDD to YYYYMMDD".
 * Supports compact ranges, single days, and legacy MONYY.
 */
export function formatPeriodLabel(period: string): string {
  if (!period || typeof period !== 'string') return '';
  const trimmed = period.trim();
  const rangeMatch =
    trimmed.match(/^(\d{8})_to_(\d{8})$/) || trimmed.match(/^(\d{8})\s+to\s+(\d{8})$/i);
  if (rangeMatch) return `${rangeMatch[1]} to ${rangeMatch[2]}`;
  if (/^\d{8}$/.test(trimmed)) return `${trimmed} to ${trimmed}`;
  const legacy = parseLegacyMonYyRange(trimmed);
  if (legacy) return `${legacy.startYmd} to ${legacy.endYmd}`;
  return trimmed.replace(/_/g, ' ');
}
